export enum eWorkOrderState {
  CREATED = 1,
  AVAILABLE_FOR_PICKING = 2,
  ON_PICKING_ROUTE = 3,
  ON_MASSIVE_PROCESS = 4,
  PICKING_FINISHED = 5,
  ON_VALIDATION = 6,
  VALIDATION_FINISHED = 7,
  ON_PREDISPATCH = 8,
  DISPATCHED = 9,
  ON_PROCESS = 10,
  FINISHED = 11,
  CANCELED = 12,
  AVAILABLE_FOR_EXTERNAL_PICKING = 13
}
